import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FormikHelpers } from 'formik';

import { RootDispatch, RootState } from 'storage/store';
import { UserCredentials } from 'storage/user/user.model';
import { Url } from 'utils/urls';
import { IsLoggedIn } from 'utils/user';
import { KISA_MIGRATION_LOGIN } from 'utils/featureTogglesNames';
import { MenuVisibilityContext } from 'components/Menu/utils/menuVisibilityContext';

import LoginForm from './LoginForm';
import LoginFormWrapper from './components/LoginFormWrapper';
import useLoginViaEmail from './hooks/useLoginViaEmail';

export type onLoginFormSubmitType<T extends UserCredentials> = (
  value: T,
  actions: FormikHelpers<T>
) => void;

const Login = () => {
  const dispatch = useDispatch<RootDispatch>();
  const navigate = useNavigate();
  const { onSubmit } = useLoginViaEmail();
  const onLoginFormSubmit: onLoginFormSubmitType<UserCredentials> = (
    values,
    actions
  ) => {
    onSubmit(values, actions);
  };
  const user = useSelector((state: RootState) => state.user);
  const { setVisible } = useContext(MenuVisibilityContext);

  useEffect(
    () =>
      function cleanup() {
        dispatch.user.resetUserStatus();
      },
    []
  );

  useEffect(() => {
    if (IsLoggedIn()) {
      navigate(Url.dashboard);
    }
    return window.scrollTo({ top: 0 });
  }, [user]);

  useEffect(() => {
    dispatch.application.getFeatureToggleState(KISA_MIGRATION_LOGIN);
    setVisible!(false);
  }, []);

  return (
    <LoginFormWrapper>
      <LoginForm onLoginFormSubmit={onLoginFormSubmit} />
    </LoginFormWrapper>
  );
};

export default Login;
